import { Button } from "@/components/ui/button";
import { ServerCrash, CheckCircle2, XCircle, RefreshCw, ArrowRight } from "lucide-react";

export const PreviewBlocked = ({ blocked, busy, onRetry, onContinueAnyway }) => {
  const checks = Object.entries(blocked?.checks || {}).filter(([, c]) => c.ok || c.required !== false);
  return (
    <div className="rounded-xl border border-red-500/25 bg-red-500/[0.06] p-5 space-y-4" data-testid="preview-blocked">
      <div className="flex items-start gap-3">
        <ServerCrash className="h-5 w-5 text-red-300 mt-0.5 flex-shrink-0" />
        <div>
          <p className="text-red-200 text-sm font-medium">I stopped the preview — a data source it depends on is down.</p>
          <p className="text-gray-400 text-xs mt-1">Running anyway would show you unverified profiles and call them prospects. Here is exactly what is unavailable{blocked?.phase === "run" ? " (it failed during the hunt)" : ""}:</p>
        </div>
      </div>
      <ul className="space-y-2" data-testid="preview-blocked-list">
        {checks.map(([key, c]) => (
          <li key={key} className="flex items-start gap-2 text-xs rounded-lg bg-black/20 px-3 py-2" data-testid={`preview-source-${key}`}>
            {c.ok ? <CheckCircle2 className="h-4 w-4 text-emerald-400 flex-shrink-0" /> : <XCircle className="h-4 w-4 text-red-400 flex-shrink-0" />}
            <div className="min-w-0">
              <p className={c.ok ? "text-gray-300" : "text-red-200"}>{c.label}<span className="text-gray-500"> — {c.detail}</span></p>
              {!c.ok && c.fix && <p className="text-gray-500 mt-0.5">Fix: {c.fix}</p>}
            </div>
          </li>
        ))}
      </ul>
      <div className="flex flex-wrap gap-2">
        <Button size="sm" onClick={onRetry} disabled={busy} className="bg-ism-teal hover:bg-ism-teal/90 text-black rounded-lg" data-testid="preview-blocked-retry-btn"><RefreshCw className="h-4 w-4 mr-1" /> Check again</Button>
        <Button size="sm" variant="ghost" onClick={onContinueAnyway} disabled={busy} className="text-gray-400 hover:text-white" data-testid="preview-blocked-continue-btn">Run anyway with what is available <ArrowRight className="h-4 w-4 ml-1" /></Button>
      </div>
    </div>
  );
};
